module.exports = __webpack_public_path__ + "img/reportChicken_4.24db2b9b.png";